module.exports = __webpack_public_path__ + "static/media/blender.8b61b044.svg";